import React from "react";
import ProtectedRoute from "../../../HOC/ProtectedRoute";

const Index = ({ children }) => {
  return <ProtectedRoute>{children}</ProtectedRoute>;
};

export default Index;
